import { FavouriteUrl } from "core/types/favourite-url.types";
import { ApiFactoryClients } from "../api.types";
import { transformReportList } from "./report.helpers";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ codeHttpClient }: ApiFactoryClients<"codeHttpClient">) => ({
  generateReport: (results: any[], practiceId: number) =>
    codeHttpClient.post("/files/legal_evidence", {
      results,
      practice_id: practiceId,
    }),
  getList: () =>
    codeHttpClient
      .get("/files/legal_evidence")
      .then(({ data }) => transformReportList(data)),
  getSocialList: () =>
    codeHttpClient
      .get("/social/reports", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Meta-token": sessionStorage.getItem("Meta_Token"),
        },
      })
      .then(({ data }) => transformReportList(data)),
  download: (fileId: number): Promise<any> =>
    codeHttpClient
      .get("/files/download?file_id=" + fileId, { responseType: "arraybuffer" })
      .then(({ data }) => data),
});
